'use strict';
import get from 'lodash/get';
import noop from 'lodash/noop';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ListItem} from '../../../components/lists/ListItem';
import {Button} from '../../../components/buttons/Button';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {StatelessStatusSelector} from '../../../core-components/selectors/components/StatelessStatusSelector';
import {PROJECT_COLLECTION} from '../../domain/ProjectDomain';
import {SvgIcon} from '../../../core-components/svg-menu-icons/SvgIcon';
import {SvgIcons} from '../../../core-components/svg-menu-icons/icons';


// TODO: implement me
export function BaseProjectCardView(props) {
  const model = props.model;

  return (
    <ListItem
      className={classNames("ProjectCard", props.className)}
      bindParam={model}
      onClick={props.onClick}
      onContextMenu={props.onShowOptions}
    >
      <div className="ProjectCard__nameWrapper">
        <span className="ProjectCard__name">
          {model.name}
        </span>
      </div>
      <span className="ProjectCard__description">
        {model.description}
      </span>
      <Button
        className="ProjectCard__optionsButton"
        iconClass="ion-chevron-down"
        bindParam={model}
        onClick={props.onShowOptions}
      />
      <div className="ProjectCard__content">
        <StatelessStatusSelector
          className="ProjectCard__status"
          labelClassName="ProjectCard__status__label"
          model={model}
          readOnly={true}
          hasPermission={noop}
          getStatusPermission={noop}
          hideValue={false}

          status={model.status}
          collection={PROJECT_COLLECTION}
        />
        <SvgIcon
          className="ProjectCard__assetIcon"
          icon={SvgIcons.Asset}
        />
        <span className="ProjectCard__assetCount">
          {props.assetCountLabel}
        </span>
      </div>
      <div className="ProjectCard__dataTags">
        {model.tags && model.tags.map(tag => `#${tag}`).join(', ')}
      </div>
    </ListItem>
  );
}

BaseProjectCardView.propTypes = {
  className: T.string,
  model: T.object.isRequired,

  assetCountLabel: T.string,

  onClick: T.func.isRequired,
  onShowOptions: T.func.isRequired,
};

export const ProjectCardView = I18nComponent(BaseProjectCardView, [
  {code: 'projects.card.metrics.assets.label', prop: 'assetCountLabel', params: getAssetCountParams},
]);

function getAssetCountParams(props) {
  return {
    count: get(props, 'model.metrics.asset.assetProjectCount', 0),
  };
}



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectCard/ProjectCardView.js